/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Executable } from './executable';
import { Artifact } from './artifact';


export interface Execution { 
    id?: string;
    name: string;
    version: string;
    kind: string;
    executable?: Executable;
    startTime?: Date;
    endTime?: Date;
    status?: Execution.StatusEnum;
    inputArtifacts?: Array<Artifact>;
    outputArtifacts?: Array<Artifact>;
    configuration?: { [key: string]: string; };
    successors?: Array<Execution>;
    annotations?: { [key: string]: string; };
}
export namespace Execution {
    export type StatusEnum = 'SUCCESS' | 'FAILED' | 'RUNNING';
    export const StatusEnum = {
        SUCCESS: 'SUCCESS' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum
    };
}


